import React from 'react';

export const Chainless = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 88.4 88.4"
      {...props}
    >
      <circle
        cx={44.2}
        cy={44.2}
        r={43.5}
        fill="#fff"
        stroke="#233762"
        strokeWidth={1.449}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
      <g fill="#010101">
        <path d="M17.6 68.5c0 .1.1.1.1.2l-.1.8c-.5 0-1-.1-1.5-.4s-.9-.6-1.3-1.1c-.4-.5-.6-.9-.7-1.4-.1-.5-.2-1-.1-1.5s.3-1 .5-1.4c.3-.4.7-.9 1.1-1.2.5-.4 1-.6 1.5-.8s1-.2 1.5-.1 1 .2 1.5.5.9.6 1.3 1.1c.4.5.6.9.7 1.4s.2.9.1 1.4h-1c-.1 0-.1-.1-.2-.1-.1-.1-.1-.2-.1-.3v-.4c0-.2-.1-.3-.2-.5s-.2-.4-.4-.7c-.2-.3-.5-.5-.8-.7-.3-.2-.6-.3-.9-.3-.3 0-.7 0-1 .1-.4.1-.7.3-1 .6-.4.3-.6.6-.8.9-.2.3-.3.6-.4.9s0 .6 0 .9c.1.3.2.6.4.9.1.2.2.3.4.4s.2.2.4.3c.1.1.3.1.4.2.1 0 .3.1.4.1h.1c0 .1 0 .2.1.2zM24.5 76.7l-1.2-.9 2.1-2.8-3-2.2-2.1 2.8-1.2-.9 4.7-6.4 1.2.9-2 2.8 3 2.2 2-2.8 1.2.9-4.7 6.4zM34.5 81l-1.1-.4c-.1 0-.2-.1-.3-.2-.1-.1-.1-.2-.1-.3v-1.7l-3.1-1.2-1.1 1.3-.2.2h-.3l-1.1-.4L33 72l1.4.5.1 8.5zm-3.7-4.6l2.4.9v-2.8-.4-.5c-.1.2-.2.3-.3.4l-.3.3-1.8 2.1zM39 81.7l-1.5-.2 1.3-7.9 1.5.2-1.3 7.9zM43.4 74.2h.1s.1 0 .1.1l.1.1 4.4 5.1v-.4-.3l-.2-4.8 1.3-.1.4 7.9h-1.1c-.1 0-.2-.1-.2-.2l-4.4-5.1v.6l.2 4.9-1.3.1-.4-7.9h1zM54.4 79.5l3.1-.9.4 1.2-4.5 1.3-2.4-7.6 1.4-.4 2 6.4zM61.2 69.2l.6 1-3.1 1.7 1.1 1.9 2.4-1.3.5 1-2.4 1.3 1.1 2 3.1-1.7.6 1-4.4 2.4-3.8-7 4.3-2.3zM66.7 66.4v.2s-.1.1-.1.2c-.1 0-.1.1-.2.1s-.3.1-.4.1c-.1 0-.3.1-.5.1-.2.1-.3.2-.5.3-.2.1-.3.3-.4.4s-.1.3-.2.4v.4c0 .1.1.2.2.4.1.1.3.2.4.2h.5c.2 0 .4-.1.6-.2.2-.1.4-.2.7-.3.2-.1.5-.2.7-.2.2-.1.5-.1.7-.1.2 0 .5.1.7.2.2.1.5.3.7.5.2.3.4.6.5.9.1.3.2.6.1 1s-.1.7-.3 1c-.2.3-.4.6-.8.9-.2.2-.4.3-.6.4-.2.1-.4.2-.7.3-.2.1-.5.1-.7.2h-.7l.1-.8v-.2c0-.1.1-.1.1-.2.1-.1.2-.1.3-.1.1 0 .3 0 .4-.1.2 0 .4-.1.5-.1.2-.1.4-.2.6-.4.3-.3.5-.6.5-.9 0-.3-.1-.6-.3-.9-.1-.2-.3-.3-.5-.3h-.5c-.2 0-.4.1-.6.2l-.6.3c-.2.1-.4.2-.7.2-.2.1-.5.1-.7.1-.2 0-.5-.1-.7-.2-.2-.1-.5-.3-.7-.6-.2-.2-.3-.5-.4-.8-.1-.3-.1-.6-.1-.9 0-.3.1-.6.3-.9.2-.3.4-.6.7-.9.4-.3.7-.5 1.1-.7s.8-.2 1.2-.2l.3 1zM70.9 61.3c0 .1.1.2.1.2 0 .1 0 .1-.1.2s-.1.1-.2.1-.2.1-.3.1c-.1.1-.3.1-.4.2-.1.1-.3.2-.4.4-.1.2-.2.3-.3.5s-.1.3-.1.4c0 .1 0 .3.1.4l.3.3c.1.1.3.2.5.2s.3-.1.5-.1.4-.2.5-.3c.2-.1.4-.3.6-.4.2-.1.4-.3.6-.4s.4-.2.7-.2h.7c.2 0 .5.2.8.4.3.2.5.5.7.8s.3.6.3.9c0 .3 0 .7-.1 1-.1.4-.3.7-.5 1.1-.2.2-.3.4-.5.6-.2.2-.4.3-.6.4l-.6.3c-.2.1-.4.1-.7.2l-.3-.8v-.2c0-.1 0-.1.1-.2s.1-.1.3-.2c.1 0 .3-.1.4-.2.2-.1.3-.1.5-.3.2-.1.3-.3.5-.5.3-.3.4-.7.3-1 0-.3-.2-.6-.5-.8-.2-.1-.3-.2-.5-.2s-.3 0-.5.1-.4.2-.5.3c-.2.1-.4.3-.6.4-.2.1-.4.3-.6.4-.2.1-.4.2-.7.2h-.7c-.3-.1-.5-.2-.8-.4l-.6-.6c-.2-.3-.2-.5-.3-.8 0-.3 0-.6.1-1 .1-.3.3-.7.5-1 .3-.4.6-.7 1-.9.4-.2.7-.4 1.1-.4l.2.8z" />
      </g>
      <defs>
        <circle id="prefix__a" cx={44.2} cy={44.2} r={36.5} />
      </defs>
      <clipPath id="prefix__b">
        <use xlinkHref="#prefix__a" overflow="visible" />
      </clipPath>
      <path
        opacity={0.31}
        clipPath="url(#prefix__b)"
        fill="#233762"
        stroke="#fff"
        strokeMiterlimit={10}
        d="M-6.2-21h102v58h-102z"
      />
      <path
        clipPath="url(#prefix__b)"
        fill="#233762"
        stroke="#fff"
        strokeMiterlimit={10}
        d="M-6.2 37h102v8h-102z"
      />
      <g clipPath="url(#prefix__b)">
        <path
          d="M54.1 34.2c-.9 0-1.7.3-2.4.7-.6-1.6-2.2-2.8-4-2.8-.9 0-1.7.3-2.4.7-.6-1.6-2.2-2.8-4-2.8-1.8 0-3.4 1.2-4 2.8-.7-.5-1.5-.7-2.4-.7-2.3 0-4.2 1.9-4.2 4.2v4.9l-2.1 2.1c-1.4 1.4-2.2 3.3-2.2 5.2v3.2c0 2 .8 3.8 2.2 5.2l4.2 4.2c3.1 3.1 7.2 4.8 11.6 4.8 7.6 0 13.8-6.2 13.8-13.8V38.4c.2-2.3-1.7-4.2-4.1-4.2zm2.2 18c0 6.4-5.2 11.7-11.7 11.7-3.8 0-7.4-1.5-10.1-4.2l-4.2-4.2c-1-1-1.6-2.3-1.6-3.7v-3.2c0-1.4.6-2.7 1.6-3.7l.6-.6V46c0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1v-9.5c0-1.2.9-2.1 2.1-2.1s2.1 1 2.1 2.1v3.2c0 .6.5 1.1 1.1 1.1s1.1-.5 1.1-1.1v-5.3c0-1.2.9-2.1 2.1-2.1 1.2 0 2.1 1 2.1 2.1v5.3c0 .6.5 1.1 1.1 1.1s1.1-.5 1.1-1.1v-3.2c0-1.2.9-2.1 2.1-2.1 1.2 0 2.1 1 2.1 2.1v3.2c0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1v-1.1c0-1.2.9-2.1 2.1-2.1 1.2 0 2.1 1 2.1 2.1v13.6z"
          fill="#fff"
        />
      </g>
      <path
        d="M56.3 52.2c0 6.4-5.2 11.7-11.7 11.7-3.8 0-7.4-1.5-10.1-4.2l-4.2-4.2c-1-1-1.6-2.3-1.6-3.7v-3.2c0-1.4.6-2.7 1.6-3.7l.6-.6V46c0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1v-9.5c0-1.2.9-2.1 2.1-2.1s2.1 1 2.1 2.1v3.2c0 .6.5 1.1 1.1 1.1s1.1-.5 1.1-1.1v-5.3c0-1.2.9-2.1 2.1-2.1 1.2 0 2.1 1 2.1 2.1v5.3c0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1v-3.2c0-1.2.9-2.1 2.1-2.1 1.2 0 2.1 1 2.1 2.1v3.2c0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1v-1.1c0-1.2.9-2.1 2.1-2.1 1.2 0 2.1 1 2.1 2.1v13.6z"
        clipPath="url(#prefix__b)"
        fill="#233762"
      />
    </svg>
  );
};
